import { graphql } from "react-apollo";
import SaveButton from '../../components/SaveButton';
import { updateNodeType } from './queries';

export default graphql(updateNodeType, { options: { refetchQueries: ['NodeTypes'] } })(SaveButton)
